import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><img parentName="p" {...{
        "src": "http://www.reeves.nl/upload/SouthAtlantic3-60pc.gif",
        "alt": "The South Atlantic Ocean"
      }}></img></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
    </ul>
    <p>{`Mid-ocean ridges are, with few exceptions, located midway between the conjugate coasts.  They can therefore be modelled
geometrically with the same rotation poles as the continental pair but with exactly half the anuglar rotation. Exceptions occur when the ridge 'jumps'
to a new location.  Understanding ridge jumps is important in working out the tectonic history of the oceans.  They often occur when the direction
of separation of the conjugate continents changes with the result that the new active rift finds a new, presumably 'easier' path.`}</p>
    <p>{`Starting with the present-day mid-ocean ridge, well-defined by earthquake epicentres and ocean-floor topography, the position of the ridge can be
mapped backwards in time.  The illustration above show the result of doing this for the classic case of the South Atlantic Ocean.  The story is fairly
straightforward in the northern half of the ocean but more complex in the early stages of the southern half which opened first. Progressive eastward
jumps of the ridge by about 350 km left areas of crust originally belonging to the Africa plate stranded on the South American plate.  In this way, the
Sao Paolo plateau and the Rio Grande Rise differ from the Walvis Ridge.  The latter may, more strictly, be simply the trail of the Tristan plume head erupting
magma that accumulated on the ocean floor.`}</p>
    <p>{`Fragmentation of the southernmost parts of South America (Patagonia) complicates the picture further.  The animation illustrates the concept of a
possible origin of Patagonia within the present-day Weddell Sea, adjacent to the Antarctica Peninsula and the Coates Land margin.`}</p>
    <p>{`Further reading: `}<a parentName="p" {...{
        "href": "http://www.reeves.nl/upload/2021a-reeves&souza-NACgeo.pdf"
      }}>{`Reeves & Souza poster, 2021.`}</a></p>
    <p><em parentName="p">{`Last update 2024 February 1`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../animations"
        }}>{`Select another animation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../gondwana"
        }}>{`Return to Gondwana main page`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      